import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../components/Loader'
import InfiniteScroll from 'react-infinite-scroll-component'
import ModeratePostCard from '../../components/ModeratePostCard'

const Moderation = () => {
    const [currentFeeds, setCurrentFeeds] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(1)

    const navigate = useNavigate()


    const { organization } = useParams()

    useEffect(() => {

        const getOrgFeeds = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/${organization}/manage/moderate`, { params: { page } })
                if (response) {
                    setIsLoading(false)
                    setCurrentFeeds((prev) => [...prev, ...response.data.posts])
                    setHasMore(response.data.length)
                }
            } catch (error) {
                setIsLoading(false)
            }
        }

        getOrgFeeds()
    }, [page])

    console.log(currentFeeds)

    const handleRefresh = () => {
        setCurrentFeeds([])
        setPage(1)
    }

    return (
        <div className="feeds-container page-left-content">
            <div className="feeds-header">
                <div className="feeds-header-content">
                    <div className="feed-header-header">
                        <h2>{organization}</h2>
                    </div>
                </div>
            </div>
            <div className="org-feed-content">
                {currentFeeds && currentFeeds.length > 0 ? (
                    <InfiniteScroll
                        dataLength={currentFeeds.length}
                        next={() => setPage((prev) => prev + 1)}
                        hasMore={hasMore}
                        refreshFunction={handleRefresh}
                    >
                        {currentFeeds.map((post) => {
                            return (
                                <div key={post._id} className="home-feed-post">
                                    <ModeratePostCard orgPost={post} />
                                </div>
                            );
                        })}
                    </InfiniteScroll>
                ) : (
                    !isLoading && <p className="not-found-msg">No Posts Found</p>
                )}
                {isLoading && <Loader />}
            </div>
            <div className="bottom-box"></div>
        </div>
    );
}

export default Moderation